module.exports = __webpack_public_path__ + "static/media/011.cd136ed2.jpg";